import script from "./EventActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventActions.vue?vue&type=script&setup=true&lang=ts"

import "./EventActions.vue?vue&type=style&index=0&id=59e0242b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59e0242b"]])

export default __exports__